import styled from '@emotion/styled';

export const LoopTag = styled.div`
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  padding: 0 4px;
  background: #f0f7ff;
  color: #336fff;
  width: fit-content;
  flex-shrink: 0;
`;

export const FixedTag = styled.div`
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  padding: 0 4px;
  background: #fffaf0;
  color: #f2a100;
  width: fit-content;
  flex-shrink: 0;
`;

export const ExtraTag = styled.div`
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  padding: 0 4px;
  background: #ebfaf3;
  color: #00bf69;
  width: fit-content;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
